
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/user",
      function () {
        return require("private-next-pages/docs/errors/user.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/user"])
      });
    }
  